export default function initNavigation(): void {
  Alpine.data("navigation", () => ({
    init() {
      window.addEventListener("scroll", () => this.closeCartPopover());

      const fixedNav = document.getElementById('fixed-nav');
      if (fixedNav) {
        const updateNavHeight = () => {
          document.documentElement.style.setProperty('--nav-height', `${fixedNav.offsetHeight}px`);
        };
        updateNavHeight();
        new ResizeObserver(updateNavHeight).observe(fixedNav);
      }

      const alertUid = this.$refs.alert?.dataset.alert;
      if (alertUid) {
        if (localStorage.getItem(`alert_${alertUid}`) === null) {
          this.$refs.alert.classList.remove('tw:hidden');
        } else {
          this.$refs.alert.remove();
        }
      }
    },
    closeCartPopover() {
      const popover = document.getElementById("cart-popover");
      popover?.hidePopover();
    },

    openDropshipmentAccess() {
      this.closeCartPopover();
      const dialog = document.getElementById(
        "dropshipment-access-request-modal",
      );
      // @ts-expect-error tailwindcss dialog
      dialog?.show();
    },

    closeAlert() {
      const alertUid = this.$refs.alert?.dataset.alert;
      if (alertUid) {
        localStorage.setItem(`alert_${alertUid}`, "closed");
        this.$refs.alert.remove();
      }
    }
  }));
}
